"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UP = 38;
exports.DOWN = 40;
exports.SPACE = 32;
exports.ENTER = 13;
exports.ESC = 27;
//# sourceMappingURL=KeyCodes.js.map